<section class="gift-section">
  
  <div class="gift-wrapper">
    
    <img src="../../../assets/img/FONDOTARJETA.png" class="gift-full-image" alt="Fondo completo" />
    
    <div class="gift-content-overlay">
      <h3 class="gift-title-cursivo">El mejor regalo es tu presencia...</h3>
      
      <p class="gift-subtitle-text">
        Por eso, para confirmar tu asistencia,<br>
        te pedimos abonar tu tarjeta.
      </p>

      <button class="btn-confirmar-boda" (click)="cbuData()">
        CONFIRMAR ASISTENCIA
      </button>
    </div>
  </div>

</section>

@if (isCard) {
  <div class="modal-overlay" (click)="closeCard()">
    <div class="modal-card" (click)="$event.stopPropagation()">
      <button class="btn-close" (click)="closeCard()">X</button>
      
      <div class="modal-content">
        <div class="datosBancarios">
        <h3 class="modal-header">Información tarjeta</h3>

        <div class="info-group">
          <span class="label">VALOR POR PERSONA</span>
          <span class="value">$45.000</span>
        </div>

        <div class="info-group">
          <span class="label">DATOS BANCARIOS</span>
          <span class="sub-label">Alias</span>
          <span class="value selectable">liliahumada.67</span>
          <span class="small-text">Titular: Liliana Marcela Ahumada</span>
        </div>
        </div>

        <form class="modal-form" (ngSubmit)="guardarInvitado()">
        <span class="label">DATOS INVITADO</span>
  
            <input 
          type="text" 
          placeholder="Nombre y apellido"
           [(ngModel)]="nombre"
    name="nombre"
    required
  >
  
  <span class="label">MENÚ ESPECIAL</span>
  
  <select [(ngModel)]="menu" name="menu">
    <option value="Ninguno">Ninguno</option>
    <option value="Celíaco">Celíaco</option>
    <option value="Vegetariano">Vegetariano</option>
    <option value="Vegano">Vegano</option>
  </select>

  <button type="button" class="btn-submit" (click)="guardarInvitado()">
  CONFIRMAR
</button>
</form>
      </div>
    </div>
  </div>
}